import React, { useState, Fragment, useEffect } from "react";

//* import css
import cssClasses from "./CreateUser.module.css";

//* import sub-component
import DropDown from "../../../Subcomponents/DropDown";
import Button from "../../../Subcomponents/Button";
import CustomInput from "../../../Subcomponents/CustomInput";

//* import mui
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";

//* import icons & images
import Event from "../../../Components/Icons/Event";
import Project from "../../../Components/Icons/Project";
import Sustenance from "../../../Components/Icons/Sustenance";
import Token from "../../../Components/Icons/Token";
import ChannelPartner from "../../../Components/Icons/ChannelPartner";
import CPSelected from "../../../Components/Icons/CPSelected";
import Payments from "../../../Components/Icons/Payments";
import Leads from "../../../Components/Icons/Leads";
import FastBooking from "../../../Components/Icons/FastBooking";
import BenefitPlan from "../../../Components/Icons/BenefitPlan";
import AllAllotments from "../../../Components/Icons/AllAllotments";
import User from "../../../Components/Icons/User";
import Settings from "../../../Components/Icons/Settings";
import HoldRelease from "../../../Components/Icons/Hold";
//* import JSON's
import tabsAccessJSON from "./jsonFiles/tabsAccessJSON.json";
import { errorTost, infoTost, successTost } from "../../../Services/Toast";
import {
  deleteRoleById,
  getAllRoles,
  getChildRoles,
  insertUserRole,
  updateUserRole,
} from "../../../Services/Roles";
import ThreeDotsMenu from "../../../Subcomponents/ThreeDotsMenu";
import { Tree, TreeNode } from "react-organizational-chart";
import { getUserByRoleName } from "../../../Services/Users";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import { ArrowBack } from "@mui/icons-material";
import CustomRadio from "../../../Subcomponents/CustomRadio";
import CpPayout from "../../../Components/CPPayout/CpPayout";
import CallLogs from "../../../Components/CallLogs/CallLogsMain";

function Hierarchy({ onTabChange = () => { }, isAssignRoleAvailable = true }) {
  const [screenToggle, setScreenToggle] = useState("hierarchy");

  const [roleObject, setRoleObject] = useState({
    title: "",
    accessibleTabs: {},
    roleId: "",
    parentRoleId: "",
  });
  const [roleObjectHelperText, setRoleObjectHelperText] = useState({
    title: "",
    accessibleTabs: "",
    parentRoleId: "",
  });

  const [roles, setRoles] = useState(null);
  const [treeRoles, setTreeRoles] = useState(null);

  const [select, setSelect] = useState(false);

  const [checkChild, setCheckChild] = useState(false);

  useEffect(() => {
    console.log(roleObject);
  }, [roleObject]);

  useEffect(() => {
    getHierarchyFromServer();
  }, []);

  // useEffect(() => {
  //   console.log("roleObjectHelperText", roleObjectHelperText);
  // }, [roleObjectHelperText])

  async function getHierarchyFromServer() {
    const response = await getAllRoles();
    console.log(response.data);
    setRoles(response.data);

    let rolesToTreeRoleData = rolesToTreeRole(response.data);
    setTreeRoles(rolesToTreeRoleData);
    console.log("rolesToTreeRole(response.data) -> ", rolesToTreeRoleData);
  }

  async function saveRole() {
    let isValidArray = [
      {
        fieldName: "title",
        isValid: isRequiredFieldValid(roleObject.title, "title", 3, null),
      },
      {
        fieldName: "parentRoleId",
        isValid: isRequiredFieldValid(
          roleObject.parentRoleId,
          "parentRoleId",
          3,
          null
        ),
      },
      {
        fieldName: "accessibleTabs",
        isValid: isRequiredFieldValid(
          Object.keys(roleObject.accessibleTabs).join(""),
          "Tabs",
          null,
          null
        ),
      },
    ];

    // console.log(isValidArray);

    if (isValidArray.some((s) => !s.isValid.flag)) {
      let obj = {};
      isValidArray.forEach((ele) => {
        if (!ele.isValid.flag) {
          obj[ele.fieldName] = ele.isValid.helperText;
        }
      });
      // console.log({ ...roleObjectHelperText, ...obj });
      setRoleObjectHelperText({ ...roleObjectHelperText, ...obj });
      return;
    }

    //todo - add Role in database
    const { title, accessibleTabs, parentRoleId } = roleObject;
    const response = await insertUserRole({
      title,
      accessibleTabs,
      parentRoleId,
    });

    console.log("role response : ", response);
    //todo - add [level] in post Object

    //* after success
    if (response.body) {
      successTost("Role created successfully.");
      setRoleObject({
        title: "",
        accessibleTabs: {},
        roleId: "",
        parentRoleId: "",
      });
      setRoleObjectHelperText({
        title: "",
        accessibleTabs: "",
        parentRoleId: "",
      });
      setScreenToggle("hierarchy");
      getHierarchyFromServer();
    } else {
      errorTost("Something went wrong !");
    }
  }

  async function updateRole() {
    let isValidArray = [
      {
        fieldName: "title",
        isValid: isRequiredFieldValid(roleObject.title, "title", 3, null),
      },
      {
        fieldName: "accessibleTabs",
        isValid: isRequiredFieldValid(
          Object.keys(roleObject.accessibleTabs).join(""),
          "Tabs",
          null,
          null
        ),
      },
    ];

    // console.log(isValidArray);

    if (isValidArray.some((s) => !s.isValid.flag)) {
      let obj = {};
      isValidArray.forEach((ele) => {
        if (!ele.isValid.flag) {
          obj[ele.fieldName] = ele.isValid.helperText;
        }
      });
      // console.log({ ...roleObjectHelperText, ...obj });
      setRoleObjectHelperText({ ...roleObjectHelperText, ...obj });
      return;
    }

    //todo - add Role in database
    const { title, accessibleTabs, roleId } = roleObject;
    const response = await updateUserRole({ title, accessibleTabs }, roleId);

    console.log("role response : ", response);
    //todo - add [level] in post Object

    //* after success
    if (response.body) {
      successTost("Role updated successfully.");
      setRoleObject({
        title: "",
        accessibleTabs: "",
      });
      setRoleObjectHelperText({
        title: "",
        accessibleTabs: "",
      });
      setScreenToggle("hierarchy");
      getHierarchyFromServer();
    } else {
      errorTost("Something went wrong !");
    }
  }

  function RenderChildData(childData) {
    // console.log("==> ", Object.keys(childData).filter(f => f !== "isAccessible" && f !== "name" && f !== "path").map(m => ({name:m, ...childData[m]})));

    // console.log('child data : ', childData);

    if (
      Object.keys(childData).filter(
        (f) => f !== "isAccessible" && f !== "name" && f !== "path"
      ).length > 0
    ) {
      console.log("----->" , Object.keys(childData))
      return (
        <>
          {Object.keys(childData)
            .filter((f) => f !== "isAccessible" && f !== "name" && f !== "path")
            .map((m) => ({ name: m, ...childData[m] }))
            .map((tabItem, tabIndex) => {
              console.log("tabbb", tabItem.name);
              return (
                <Fragment key={`parent_tab_${tabItem.name}_${tabIndex}`}>
                  <div
                    className={`${cssClasses.iconTabCheckBoxContainer} ${cssClasses.childCheckBoxContainer} action_tab_ddd`}
                  >
                    {tabItem.name === "Show Allotments" ||
                      tabItem.name === "Show CRM" ||
                      tabItem.name === "Show Tokens Payments" ||
                      tabItem.name === "Show Allotments Payments" ||
                      tabItem.name === "Show Leads" ||
                      tabItem.name === "Show All Analysis" ||
                      tabItem.name === "Show Sales Analysis" ||
                      tabItem.name === "Show CP Analysis" ||
                      tabItem.name === "requestType" ||
                      tabItem.name === "allRequestType" ||
                      tabItem.name === "Show Events" ||
                      tabItem.name === "Show CallLogs" ||
                      tabItem.name === "Show CpSourcing" ||
                      tabItem.name === "Show CP Site Visit" ||
                      tabItem.name === "Show Site Visits" ||
                      tabItem.name === "Show Sales Dashboard Analysis" ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: "2rem",
                        }}
                      >
                        {tabItem.name === "Show Allotments" ? (
                          <p>Show Allotments : </p>
                        ) : tabItem.name === "Show CRM" ? (
                          <p>Show CRM : </p>
                        ) : tabItem.name === "Show Tokens Payments" ? (
                          <p>Show Tokens Payments : </p>
                        ) : tabItem.name === "Show Events" ? (
                          <p>Show Events : </p>
                        ) : tabItem.name === "Show Leads" ? (
                          <p>Show Leads : </p>
                        ) : tabItem.name === "Show All Analysis" ? (
                          <p>Show All Analysis : </p>
                        ) : tabItem.name === "Show Sales Analysis" ? (
                          <p>Show Sales Analysis : </p>
                        ) : tabItem.name === "Show CP Analysis" ? (
                          <p>Show CP Analysis : </p>
                        ) : tabItem.name === "Show Events Analysis" ? (
                          <p>Show Events Analysis : </p>
                        ) : tabItem.name === "requestType" ? (
                          <p>Type : </p>
                        ) : tabItem.name === "allRequestType" ? (
                          <p>Type : </p>
                        ) : tabItem.name === "Show CallLogs" ? (
                          <p>Show CallLogs : </p>
                        ) : tabItem.name === "Show CpSourcing" ? (
                          <p>Show CpSourcing : </p>
                        ) : tabItem.name === "Show CP Site Visit" ? (
                          <p>Show CP Site Visit : </p>
                        ) : tabItem.name === "Show Site Visits" ? (
                          <p>Show Site Visits : </p>
                        ) : tabItem.name === "Show Sales Dashboard Analysis" ? (
                          <p>Show Sales Dashboard Analysis : </p>
                        ) : (
                          <p>Show Allotments Payments: </p>
                        )}
                        <CustomRadio
                          // checked={roleObject.accessibleTabs["All Allotments"]["Show Allotments"].show}
                          optionList={
                            tabItem.name === "Show Events"
                              ? ["All", "Assinged Users"]
                              : (tabItem.name === "requestType" || tabItem.name === "allRequestType")
                                ? ['Request', 'Approve'] : tabItem.name === "Show CRM" ? ["All", "Self"]
                                  : tabItem.name === "Show CallLogs" ? ["All", "Team Wise"]
                                    : tabItem.name === "Show CpSourcing" ? ["All", "Team Wise"]
                                    : tabItem.name === "Show CP Site Visit" ? ["All", "Team Wise"]
                                    : tabItem.name === "Show Site Visits" ? ["All", "Team Wise"]
                                    : tabItem.name === "Show Sales Dashboard Analysis" ? ["All", "Team Wise"] : ["All", "Team wise"]

                          }
                          value={
                            tabItem.name === "Show Allotments"
                              ? roleObject.accessibleTabs["All Allotments"]["Show Allotments"]?.show
                              : tabItem.name === "Show CRM" ? roleObject.accessibleTabs["All Allotments"]["CRM"][
                                "Show CRM"
                              ]?.show : tabItem.name === "Show Tokens Payments"
                                ? roleObject.accessibleTabs["Payments"]["Show Tokens Payments"]?.show
                                : tabItem.name === "Show Events"
                                  ? roleObject.accessibleTabs["Event"]["Show Events"]?.show
                                  : tabItem.name === "Show Leads"
                                    ? roleObject.accessibleTabs["Leads"]["Show Leads"]?.show
                                    : tabItem.name === "Show All Analysis"
                                      ? roleObject.accessibleTabs["Dashboard"]?.["All"]?.["Show All Analysis"]?.show
                                      : tabItem.name === "Show Sales Analysis"
                                        ? roleObject.accessibleTabs["Dashboard"]?.["Sales"]["Show Sales Analysis"]?.show
                                        : tabItem.name === "Show CP Analysis"
                                          ? roleObject.accessibleTabs["Dashboard"]?.["CP"]["Show CP Analysis"]?.show
                                          : tabItem.name === "requestType"
                                            ? roleObject.accessibleTabs["Leads"]["Allotment"]['Change unit']["requestType"]?.show
                                            : tabItem.name === "Show CallLogs"
                                              ? roleObject.accessibleTabs["CallLogs"]["Show CallLogs"]?.show
                                              : tabItem.name === "Show CpSourcing"
                                                ? roleObject.accessibleTabs["CpSourcing"]?.["Show CpSourcing"]?.show
                                              : tabItem.name === "Show CP Site Visit"
                                                ? roleObject.accessibleTabs["CpSourcing"]?.["Show CP Site Visit"]?.show
                                              : tabItem.name === "Show Site Visits"
                                                ? roleObject.accessibleTabs["Site Visit"]?.["Show Site Visits"]?.show
                                              : tabItem.name === "allRequestType"
                                                ? roleObject.accessibleTabs["Leads"]["All"]['Change unit']["allRequestType"]?.show
                                              : tabItem.name === "Show Sales Dashboard Analysis"
                                                ? roleObject.accessibleTabs["Sales Dashboard"]?.["Show Sales Dashboard Analysis"]?.show
                                                : roleObject.accessibleTabs["Payments"]["Show Allotments Payments"]?.show

                          }
                          onChangeValue={(e) => {
                            setRoleObject((pre) => {
                              console.log(tabItem.name);
                              if (tabItem.name === "Show Allotments") {
                                if (
                                  pre.accessibleTabs["All Allotments"][
                                  "Show Allotments"
                                  ]
                                ) {
                                  pre.accessibleTabs["All Allotments"][
                                    "Show Allotments"
                                  ].show = e;
                                } else {
                                  pre.accessibleTabs["All Allotments"][
                                    "Show Allotments"
                                  ] = { show: "All" };
                                }
                              } else if (tabItem.name === "Show CRM") {
                                if (
                                  pre.accessibleTabs["All Allotments"]["CRM"][
                                  "Show CRM"
                                  ]
                                ) {
                                  pre.accessibleTabs["All Allotments"]["CRM"][
                                    "Show CRM"
                                  ].show = e;
                                } else {
                                  pre.accessibleTabs["All Allotments"]["CRM"][
                                    "Show CRM"
                                  ] = { show: "All" };
                                }
                              } else if (tabItem.name === "Show Tokens Payments") {
                                if (pre.accessibleTabs["Payments"]["Show Tokens Payments"]) {
                                  pre.accessibleTabs["Payments"]["Show Tokens Payments"].show = e;
                                } else {
                                  pre.accessibleTabs["Payments"][
                                    "Show Tokens Payments"
                                  ] = { show: "All" };
                                }
                              } else if (
                                tabItem.name === "Show Allotments Payments"
                              ) {
                                if (
                                  pre.accessibleTabs["Payments"][
                                  "Show Allotments Payments"
                                  ]
                                ) {
                                  pre.accessibleTabs["Payments"][
                                    "Show Allotments Payments"
                                  ].show = e;
                                } else {
                                  pre.accessibleTabs["Payments"][
                                    "Show Allotments Payments"
                                  ] = { show: "All" };
                                }
                              } else if (tabItem.name === "Show Events") {
                                if (
                                  pre.accessibleTabs["Event"]["Show Events"]
                                ) {
                                  pre.accessibleTabs["Event"][
                                    "Show Events"
                                  ].show = e;
                                } else {
                                  pre.accessibleTabs["Event"]["Show Events"] = {
                                    show: "All",
                                  };
                                }
                              } else if (tabItem.name === "Show Leads") {
                                if (pre.accessibleTabs["Leads"]["Show Leads"]) {
                                  pre.accessibleTabs["Leads"][
                                    "Show Leads"
                                  ].show = e;
                                } else {
                                  pre.accessibleTabs["Leads"]["Show Leads"] = {
                                    show: "All",
                                  };
                                }
                              } else if (tabItem.name === "Show All Analysis") {
                                if (pre.accessibleTabs["Dashboard"]?.["All"]?.["Show All Analysis"]) {
                                  pre.accessibleTabs["Dashboard"]["All"]["Show All Analysis"].show = e;
                                } else {
                                  pre.accessibleTabs["Dashboard"]["All"][
                                    "Show All Analysis"
                                  ] = { show: "All" };
                                }
                              } else if (
                                tabItem.name === "Show Sales Analysis"
                              ) {
                                if (
                                  pre.accessibleTabs["Dashboard"]["All"][
                                  "Show Sales Analysis"
                                  ]
                                ) {
                                  pre.accessibleTabs["Dashboard"]["All"][
                                    "Show Sales Analysis"
                                  ].show = e;
                                } else {
                                  pre.accessibleTabs["Dashboard"]["All"][
                                    "Show Sales Analysis"
                                  ] = { show: "All" };
                                }
                              } else if (tabItem.name === "Show CP Analysis") {
                                if (
                                  pre.accessibleTabs["Dashboard"]["All"][
                                  "Show CP Analysis"
                                  ]
                                ) {
                                  pre.accessibleTabs["Dashboard"]["All"][
                                    "Show CP Analysis"
                                  ].show = e;
                                } else {
                                  pre.accessibleTabs["Dashboard"]["All"][
                                    "Show CP Analysis"
                                  ] = { show: "All" };
                                }
                              } else if (tabItem.name === "Show Events Analysis") {
                                if (
                                  pre.accessibleTabs["Dashboard"]["All"][
                                  "Show Events Analysis"
                                  ]
                                ) {
                                  pre.accessibleTabs["Dashboard"]["All"][
                                    "Show Events Analysis"
                                  ].show = e;
                                } else {
                                  pre.accessibleTabs["Dashboard"]["All"][
                                    "Show Events Analysis"
                                  ] = { show: "All" };
                                }
                              }
                              else if (tabItem.name === "requestType") {
                                if (
                                  pre.accessibleTabs["Leads"]["Allotment"][
                                  "Change unit"
                                  ]["requestType"]
                                ) {
                                  pre.accessibleTabs["Leads"]["Allotment"][
                                    "Change unit"
                                  ]["requestType"].show = e;
                                } else {
                                  pre.accessibleTabs["Leads"]["Allotment"][
                                    "Change unit"
                                  ]["requestType"] = { show: "Request" };
                                }
                              } else if (tabItem.name === "allRequestType") {
                                if (
                                  pre.accessibleTabs["Leads"]["All"][
                                  "Change unit"
                                  ]["allRequestType"]
                                ) {
                                  pre.accessibleTabs["Leads"]["All"][
                                    "Change unit"
                                  ]["allRequestType"].show = e;
                                } else {
                                  pre.accessibleTabs["Leads"]["All"][
                                    "Change unit"
                                  ]["allRequestType"] = { show: "Request" };
                                }
                              } else if (tabItem.name === "Show CallLogs") {
                                if (pre.accessibleTabs["CallLogs"]["Show CallLogs"]) {
                                  pre.accessibleTabs["CallLogs"]["Show CallLogs"].show = e;
                                } else {
                                  pre.accessibleTabs["CallLogs"]["Show CallLogs"] = { show: "All" };
                                }
                              } else if (tabItem.name === "Show CpSourcing") {
                                if (!pre.accessibleTabs["CpSourcing"]) {
                                  pre.accessibleTabs["CpSourcing"] = {};
                                }
                                if (pre.accessibleTabs["CpSourcing"]["Show CpSourcing"]) {
                                  pre.accessibleTabs["CpSourcing"]["Show CpSourcing"].show = e;
                                } else {
                                  pre.accessibleTabs["CpSourcing"]["Show CpSourcing"] = { show: "All" };
                                }
                              } else if (tabItem.name === "Show CP Site Visit") {
                                if (!pre.accessibleTabs["CpSourcing"]) {
                                  pre.accessibleTabs["CpSourcing"] = {};
                                }
                                if (pre.accessibleTabs["CpSourcing"]["Show CP Site Visit"]) {
                                  pre.accessibleTabs["CpSourcing"]["Show CP Site Visit"].show = e;
                                } else {
                                  pre.accessibleTabs["CpSourcing"]["Show CP Site Visit"] = { show: "All" };
                                }
                              } else if (tabItem.name === "Show Site Visits") {
                                if (!pre.accessibleTabs["Site Visit"]) {
                                  pre.accessibleTabs["Site Visit"] = {};
                                }
                                if (pre.accessibleTabs["Site Visit"]["Show Site Visits"]) {
                                  pre.accessibleTabs["Site Visit"]["Show Site Visits"].show = e;
                                } else {
                                  pre.accessibleTabs["Site Visit"]["Show Site Visits"] = { show: "All" };
                                }
                              } else if (tabItem.name === "Show Sales Dashboard Analysis") {
                                if (!pre.accessibleTabs["Sales Dashboard"]) {
                                  pre.accessibleTabs["Sales Dashboard"] = {};
                                }
                                if (pre.accessibleTabs["Sales Dashboard"]["Show Sales Dashboard Analysis"]) {
                                  pre.accessibleTabs["Sales Dashboard"]["Show Sales Dashboard Analysis"].show = e;
                                } else {
                                  pre.accessibleTabs["Sales Dashboard"]["Show Sales Dashboard Analysis"] = { show: "All" };
                                }
                              }
                              return { ...pre };
                            });
                          }}
                        />
                      </div>
                    ) : (
                      <>
                        <Checkbox
                          sx={[checkBox_sx]}
                          checked={
                            getObjectValueWithPath(
                              { ...roleObject.accessibleTabs },
                              childData?.path.join(".")
                            )[tabItem.name]?.isAccessible
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              //todo push
                              setRoleObject((prevState) => {
                                console.log("skdflsdf");
                                const newState = { ...prevState };
                                setValuesWithStringPath(
                                  newState,
                                  `accessibleTabs.${childData?.path.join(
                                    "."
                                  )}.${tabItem.name}.isAccessible`,
                                  true
                                );
                                return newState;
                              });

                              setCheckChild(false);
                            } else {
                              console.log("joo");
                              setCheckChild(true);
                              //todo pop
                              setRoleObject((prevState) => {
                                const newState = { ...prevState };
                                let _newValue = getObjectValueWithPath(
                                  JSON.parse(
                                    JSON.stringify({ ...tabsAccessJSON })
                                  ),
                                  `${childData?.path.join(".")}.${tabItem.name}`
                                );

                                console.log("==> ", _newValue);

                                setValuesWithStringPath(
                                  newState,
                                  `accessibleTabs.${childData?.path.join(
                                    "."
                                  )}.${tabItem.name}`,
                                  false
                                );
                                return { ...newState };
                              });
                            }
                          }}
                        />
                        <p htmlFor={`parent_tab_${tabItem.name}_${tabIndex}`}>
                          {tabItem.name}
                        </p>
                      </>
                    )}
                  </div>
                  {getObjectValueWithPath(
                    { ...roleObject.accessibleTabs },
                    childData?.path.join(".")
                  )[tabItem.name]?.isAccessible &&
                    Object.keys(tabItem).filter(
                      (f) =>
                        f !== "isAccessible" && f !== "name" && f !== "path"
                    ).length > 0 && (
                      <div className={`${cssClasses.childCheckBoxContainer}`}>
                        {RenderChildData({
                          ...tabItem,
                          path: [...childData.path, tabItem.name],
                        })}
                      </div>
                    )}
                </Fragment>
              );
            })}
        </>
      );
    } else {
      return <p>End</p>;
    }
  }

  // console.log("Object.keys(tabs).map(m => ({name:m, ...tabs[m]}))",Object.keys(tabs).map(m => ({name:m, ...tabs[m]})));

  const editRole = (_title, _accessibleTabs, _roleId, _parentRoleId) => {
    // console.log({ title: _title, accessibleTabs: _accessibleTabs, roleId: _roleId, parentRoleId: _parentRoleId });
    console.log(JSON.parse(JSON.stringify(_accessibleTabs)));
    setRoleObject({
      title: _title,
      accessibleTabs: JSON.parse(JSON.stringify(_accessibleTabs)),
      roleId: _roleId,
      parentRoleId: _parentRoleId,
    });
    setScreenToggle("create role");
  };

  const deleteRole = async (_roleObj) => {
    console.log("delete role", _roleObj);

    presentLoader();
    const getUserByRoleNameResponse = await getUserByRoleName(_roleObj?.roleId);
    // console.log("getUserByRoleNameResponse -> ", getUserByRoleNameResponse);

    if (getUserByRoleNameResponse.data) {
      if (getUserByRoleNameResponse.data.length > 0) {
        infoTost("This role assign to some users.");
        dismissLoader();
      } else {
        console.log("Delete");
        const getChildRolesResponse = await getChildRoles(_roleObj?.roleId);
        if (getChildRolesResponse.data && getChildRolesResponse.count > 0) {
          console.log(
            "getChildRolesResponse.data => ",
            getChildRolesResponse.data
          );
          for (const roleItem of getChildRolesResponse.data) {
            let updateUserRoleResponse = await updateUserRole(
              { parentRoleId: _roleObj?.parentRoleId },
              roleItem.roleId
            );
            console.log("updateUserRoleResponse => ", updateUserRoleResponse);
          }
        }
        const deleteRoleByIdResponse = await deleteRoleById(_roleObj?.roleId);
        if (deleteRoleByIdResponse.data) {
          successTost("Role Deleted Successfully !");
        } else {
          errorTost("Something went wrong!");
        }
        getHierarchyFromServer();
        dismissLoader();
      }
    } else {
      errorTost("Something went wrong!");
      dismissLoader();
    }

    // const response = await deleteRoleById(roleId);
    // console.log(response)
    // if (response.data) {
    //   getHierarchyFromServer();
    //   successTost("Role Deleted Successfully !");
    // } else {
    //   errorTost("Something went wrong!");
    // }
  };

  function ChildTree({ childData }) {
    if (Array.isArray(childData) && childData?.length > 0) {
      return childData.map((childrenData, childrenIndex) => (
        <Fragment key={`TreeNode-${childrenData.roleId}-${childrenIndex}`}>
          {childrenData?.children?.length > 0 ? (
            <TreeNode label={StyledNode(childrenData)}>
              {/* {ChildTree(childrenData.children)} */}
              <ChildTree childData={childrenData.children} />
            </TreeNode>
          ) : (
            <TreeNode label={StyledNode(childrenData)} />
          )}
        </Fragment>
      ));
    }
  }
  const StyledNode = (content) => (
    <div
      className={cssClasses.styledNodeContainer}
      style={{
        padding: "2rem 3.5rem 2rem 2.5rem",
        borderRadius: "5px",
        display: "inline-block",
        border: "2px solid #D0D5DD",
        background: "#FFFFFF",
        fontFamily: "Inter-Medium",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "1.8rem",
        lineHeight: "2.8rem",
        color: "#344054",
      }}
    >
      <ThreeDotsMenu
        list={content?.parentRoleId ? ["Edit", "Delete"] : ["Edit"]}
        selectedValue={(e) => {
          // console.log(e);
          // let _content = JSON.parse(JSON.stringify(content));
          // delete _content.children;

          // console.log(JSON.parse(JSON.stringify(content?.accessibleTabs)));
          if (e === "Edit") {
            editRole(
              content?.title,
              JSON.parse(JSON.stringify(content?.accessibleTabs)),
              content?.roleId,
              content?.parentRoleId
            );
          } else if (e === "Delete") {
            deleteRole(content);
          }
        }}
        style={{
          position: "absolute",
          right: "-7px",
          top: "0px",
        }}
      />
      {content?.title}
    </div>
  );

  // useState(() => {
  //   console.log('role obuject', roleObjectHelperText);
  // }, [roleObjectHelperText])

  return (
    <>
      <div className={cssClasses.hierarchyWrapper}>
        {screenToggle === "hierarchy" ? (
          <>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
            >
              <div>
                {((!isAssignRoleAvailable &&
                  tabsAccessJSON?.["Hierarchy"]?.["Create Role"]
                    ?.isAccessible) ||
                  (isAssignRoleAvailable &&
                    tabsAccessJSON?.["Users"]?.["Create Role"]
                      ?.isAccessible)) && (
                  <Button
                    style={{
                      color: "#fff",
                      backgroundColor: "#1570EF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Roboto-Regular",
                    }}
                    btnName={"+ Create Role"}
                    clicked={() => {
                      // navigate("/home/users/createUser");
                      setScreenToggle("create role");
                    }}
                    // btnIcon={<AddIcon style={{width: "15px", height: "15px"}}/>}
                    iconPosition={"left"}
                  />
                )}
              </div>
            </Box>
            <div className={cssClasses.hierarchyContainer}>
              {roles && roles?.length > 0 && (
                // roles.map((hierarchyItem, hierarchyIndex) => (
                //   <Fragment key={`${hierarchyItem.title}_${hierarchyIndex}`}>
                //     <div className={cssClasses.hierarchyCard}>
                //       {hierarchyItem.title}

                //       <ThreeDotsMenu
                //         list={["Edit", "Delete"]}
                //         selectedValue={(e) => {
                //           if (e === "Edit") {
                //             editRole(hierarchyItem.title, hierarchyItem.accessibleTabs, hierarchyItem.roleId);
                //           } else if (e === "Delete") {
                //             deleteRole(hierarchyItem.roleId);
                //           }
                //         }}
                //         style={{
                //           position: 'absolute !important',
                //           top: '-6px !important',
                //           right: '-12px !important'
                //         }}
                //       />

                //       {/* <Button
                //         style={{
                //           color: "#fff",
                //           backgroundColor: "#1570EF",
                //           fontSize: "1.4rem",
                //           lineHeight: "2rem",
                //           fontFamily: "Roboto-Regular",
                //         }}
                //         btnName={"Edit"}
                //         clicked={() => {
                //           editRole(hierarchyItem.title, hierarchyItem.accessibleTabs, hierarchyItem.roleId);
                //         }}
                //         // btnIcon={<AddIcon style={{width: "15px", height: "15px"}}/>}
                //         iconPosition={"left"}
                //       />

                //       <Button
                //         style={{
                //           color: "#fff",
                //           backgroundColor: "red",
                //           fontSize: "1.4rem",
                //           lineHeight: "2rem",
                //           fontFamily: "Roboto-Regular",
                //         }}
                //         btnName={"Delete"}
                //         clicked={() => {
                //           deleteRole(hierarchyItem.roleId);
                //         }}
                //         // btnIcon={<AddIcon style={{width: "15px", height: "15px"}}/>}
                //         iconPosition={"left"}
                //       /> */}

                //     </div>
                //     {(hierarchyIndex !== (roles?.length - 1)) && <div className={cssClasses.hierarchyCardVerticalLine}></div>}

                //   </Fragment>
                // ))
                <Tree label={StyledNode(treeRoles)} lineColor={"#1570EF"}>
                  <ChildTree childData={treeRoles.children} />
                </Tree>
              )}
              {roles?.length === 0 && (
                <Box flex={1} display={"flex"} alignItems={"center"}>
                  <Typography fontSize={"3em"}>
                    Roles not created yet...
                  </Typography>
                </Box>
              )}
            </div>
          </>
        ) : (
          <div style={{ overflow: "auto", padding: "5px" }}>
            <Box width={"fit-Content"} mb={"2rem"}>
              <Button
                style={{
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                  color: "#000000",
                  backgroundColor: "#FFFFFF",
                  border: "none",
                  boxShadow: "none",
                }}
                padding={"0"}
                btnIcon={
                  <ArrowBack
                    style={{ width: "2rem", height: "2rem", color: "#000000" }}
                  />
                }
                iconPosition={"left"}
                btnName={"Hierarchy"}
                clicked={() => {
                  setScreenToggle("hierarchy");
                  setRoleObject({
                    title: "",
                    accessibleTabs: {},
                    roleId: "",
                    parentRoleId: "",
                  });
                  setRoleObjectHelperText({
                    title: "",
                    accessibleTabs: "",
                    parentRoleId: "",
                  });
                }}
              />
            </Box>
            <Box
              display={"flex"}
              flexDirection={{ xs: "column", sm: "row" }}
              columnGap={"2rem"}
            >
              <div className={cssClasses.inputWrapper} style={{ flex: 1 }}>
                <label>
                  Role Name <span>*</span>
                </label>
                <CustomInput
                  placeholder="Enter role Name"
                  value={roleObject?.title}
                  helperText={roleObjectHelperText.title}
                  handleChange={(_value) => {
                    setRoleObject({ ...roleObject, title: _value });
                    let _isValid = isRequiredFieldValid(
                      _value,
                      "title",
                      3,
                      null
                    );
                    setRoleObjectHelperText({
                      ...roleObjectHelperText,
                      title: _isValid.helperText,
                    });
                  }}
                />
              </div>

              <div className={cssClasses.inputWrapper} style={{ flex: 1 }}>
                <label>
                  Parent Role <span>*</span>
                </label>
                <DropDown
                  disable={
                    roleObject.roleId && !roleObject.parentRoleId ? true : false
                  }
                  placeholder="Select Parent Role"
                  list={roles.map((m) => ({
                    label: m?.title,
                    value: m?.roleId,
                  }))}
                  onChangeSelect={(_value) => {
                    setRoleObject({ ...roleObject, parentRoleId: _value });
                    let _isValid = isRequiredFieldValid(
                      _value,
                      "parentRoleId",
                      3,
                      null
                    );
                    setRoleObjectHelperText({
                      ...roleObjectHelperText,
                      parentRoleId: _isValid.helperText,
                    });
                  }}
                  selectedValue={roleObject.parentRoleId}
                  style={{ selectedColor: "#98A2B3", background: "#F2F4F7" }}
                  helperText={roleObjectHelperText.parentRoleId}
                />
              </div>
            </Box>

            <div className={cssClasses.inputWrapper}>
              <label>Select Tabs :</label>
              <div
                className={cssClasses.tabAccessWrapper}
                style={{
                  border: `${
                    roleObjectHelperText.accessibleTabs === ""
                      ? "none"
                      : "1px solid red"
                  }`,
                  borderRadius: "1.5rem",
                  marginTop: "0.5rem",
                }}
              >
                {Object.keys(tabsAccessJSON)
                  .map((m) => ({ name: m, ...tabsAccessJSON[m] }))
                  .map((tabItem, tabIndex) => (
                    <Fragment key={`parent_tab_${tabItem.name}_${tabIndex}`}>
                      <div className={cssClasses.iconTabCheckBoxContainer}>
                        <Checkbox
                          sx={[checkBox_sx]}
                          // checked={roleObject.accessibleTabs.hasOwnProperty(tabItem.name)}
                          checked={
                            roleObject.accessibleTabs[tabItem.name]
                              ?.isAccessible
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              //todo push
                              setRoleObject((pre) => {
                                pre.accessibleTabs[tabItem.name] = JSON.parse(
                                  JSON.stringify({
                                    ...tabsAccessJSON[tabItem.name],
                                  })
                                );
                                pre.accessibleTabs[
                                  tabItem.name
                                ].isAccessible = true;
                                return { ...pre };
                              });
                              setRoleObjectHelperText({
                                ...roleObjectHelperText,
                                accessibleTabs: "",
                              });
                            } else {
                              //todo pop
                              let pre = { ...roleObject.accessibleTabs };
                              delete pre[tabItem.name];
                              setRoleObject((preValue) => {
                                preValue.accessibleTabs = pre;
                                return { ...preValue };
                              });
                              if (Object.keys(pre).length === 0) {
                                setRoleObjectHelperText({
                                  ...roleObjectHelperText,
                                  accessibleTabs: "Please Select Tabs.",
                                });
                              }
                            }
                          }}
                        />
                        {tabIcons[tabItem.name]}
                        <p htmlFor={`parent_tab_${tabItem.name}_${tabIndex}`}>
                          {tabItem.name}
                        </p>
                      </div>
                      {roleObject.accessibleTabs[tabItem.name] &&
                        Object.keys(tabItem).filter(
                          (f) => f !== "isAccessible" && f !== "name"
                        ).length > 0 && (
                          <div>
                            {RenderChildData({
                              ...tabItem,
                              path: [tabItem.name],
                            })}
                          </div>
                        )}
                    </Fragment>
                  ))}
              </div>
              <p
                style={{
                  font: "Inter-Medium",
                  fontSize: "1.4rem",
                  color: "#d32f2f",
                  paddingTop: "0.5rem",
                }}
              >
                {roleObjectHelperText.accessibleTabs}
              </p>
            </div>
          </div>
        )}
      </div>

      <div
        className={cssClasses.buttonWrapper}
        style={{ justifyContent: "flex-end" }}
      >
        <div>
          {screenToggle === "hierarchy" && isAssignRoleAvailable ? (
            <Button
              style={{
                color: "#fff",
                backgroundColor: "#1570EF",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Roboto-Regular",
              }}
              btnName={"Assign Role"}
              clicked={() => {
                onTabChange("Assign Role");
              }}
            />
          ) : roleObject.roleId ? (
            <Button
              style={{
                color: "#fff",
                backgroundColor: "#1570EF",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Roboto-Regular",
              }}
              btnName={"Update Role"}
              clicked={() => {
                updateRole();
              }}
              disable={
                !(
                  isRequiredFieldValid(
                    Object.keys(roleObject.accessibleTabs).join(""),
                    "Tabs",
                    null,
                    null
                  ).flag &&
                  isRequiredFieldValid(roleObject.title, "title", 3, null).flag
                )
              }
            />
          ) : (
            screenToggle === "create role" && (
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "#1570EF",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                  fontFamily: "Roboto-Regular",
                }}
                btnName={"Save Role"}
                clicked={() => {
                  saveRole();
                }}
                disable={
                  !(
                    isRequiredFieldValid(
                      Object.keys(roleObject.accessibleTabs).join(""),
                      "Tabs",
                      null,
                      null
                    ).flag &&
                    isRequiredFieldValid(roleObject.title, "title", 3, null)
                      .flag
                  )
                }
              />
            )
          )}
        </div>
      </div>
    </>
  );
}

export default Hierarchy;

const tabIcons = {
  "All Allotments": <AllAllotments color={"#667085"} />,
  "Benefit Plan": <BenefitPlan color={"#667085"} fill={"none"} />,
  "Channel Partner": <ChannelPartner color={"#667085"} fill={"none"} />,
  Event: <Event color={"#667085"} fill={"none"} />,
  FastBooking: <FastBooking color={"#667085"} fill={"none"} />,
  Leads: <Leads color={"#667085"} fill={"none"} />,
  Payment: <Payments color={"#667085"} fill={"none"} />,
  Project: <Project color={"#667085"} fill={"none"} />,
  Settings: <Settings color={"#667085"} />,
  Sustenance: <Sustenance color={"#667085"} fill={"none"} />,
  Token: <Token color={"#667085"} fill={"none"} />,
  Users: <User color={"#667085"} fill={"none"} />,
  Queue: <Leads color={"#667085"} fill={"none"} />,
  "CP Payout": <CpPayout color={"#667085"} fill={"none"} />,
  "CallLogs": <Settings color={"#667085"} fill={"none"} />,
  "Sales Manager Persona": <Settings color={"#667085"} fill={"none"} />,
  "WorkTransfer": <User color={"#667085"} fill={"none"} />,
};

const checkBox_sx = {};

function getObjectValueWithPath(object, path) {
  path = path.split(".");
  var step;
  while ((step = path.shift())) {
    object = object[step];
  }
  return object;
}

function setValuesWithStringPath(obj, path, value) {
  // console.log({obj, path, value});
  var schema = obj;
  var pList = path.split(".");
  var len = pList.length;
  for (var i = 0; i < len - 1; i++) {
    var elem = pList[i];
    if (!schema[elem]) schema[elem] = {};
    schema = schema[elem];
  }
  schema[pList[len - 1]] = value;
}

function isRequiredFieldValid(inputText, fieldName, min, max) {
  inputText = inputText.toString();
  let flag = true;
  let helperText = "";
  if (!inputText || inputText === "") {
    flag = false;
    helperText = `Please Enter ${fieldName}.`;
  } else if (min && inputText.length < min) {
    flag = false;
    helperText = `Please Enter at least ${min} words.`;
  } else if (max && inputText.length > max) {
    flag = false;
    helperText = `Please Enter less than ${max} words.`;
  }
  return { flag, helperText };
}

function rolesToTreeRole(data) {
  var childrenById = {};
  var nodes = {};
  var i, row, root;
  for (i = 0; i < data.length; i++) {
    row = data[i];
    nodes[row.roleId] = { ...JSON.parse(JSON.stringify(row)), children: [] };
    if (row.parentRoleId === null) {
      root = row.roleId;
    } else if (childrenById[row.parentRoleId] === undefined) {
      childrenById[row.parentRoleId] = [row.roleId];
    } else {
      childrenById[row.parentRoleId].push(row.roleId);
    }
  }
  function recursionForFillChildren(roleId) {
    if (childrenById[roleId] !== undefined) {
      for (var i = 0; i < childrenById[roleId].length; i++) {
        var childId = childrenById[roleId][i];
        nodes[roleId].children.push(recursionForFillChildren(childId));
      }
    }
    return nodes[roleId];
  }
  return recursionForFillChildren(root);
}
